import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  IconButton,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styled from "styled-components";
import { useNotification } from "../../context/NotificationContext";
import TableWithPagination from "./TableWithPagination";
import AddAccessLevelModal from "./AddAccessLevelModal";
import { RemoveUserAccessLevel } from "../../api/Access";
import api from "../../api/config";

const Header = styled(DialogTitle)`
  background-color: #28929c;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
`;

const Content = styled(DialogContent)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px !important;
  background-color: #2b3342;
  color: white;
`;

export default function AccessLevel({
  open,
  onClose,
  accessLevels = [],
  clients = [],
  accessLevelsLoading = false,
  refreshAccessLevels = () => {},
  onSaveSuccess = () => {},
}) {
  const { showNotification } = useNotification();
  const [openAddAccessLevelModal, setOpenAddAccessLevelModal] = useState(false);
  const [isAccessLevelEdit, setIsAccessLevelEdit] = useState(false);
  const columns = [
    { id: "uuid", label: "ID", display: "hidden" },
    { id: "name", label: "Name" },
    { id: "description", label: "Description" },
    { id: "permissions", label: "Permissions", display: "hidden" },
    { id: "timeAdded", label: "Time Added", display: "hidden" },
    { id: "timeUpdated", label: "Time Updated", display: "hidden" },
    {
      id: "actions",
      label: "Actions",
      buttons: [
        { label: "Edit", id: "edit" },
        { label: "Delete", id: "delete" },
      ],
    },
  ];
  const [selectedAccessLevel, setSelectedAccessLevel] = useState({});

  const handleAddAccessLevel = () => {
    setOpenAddAccessLevelModal(true);
    console.log("Add Access Level");
  };

  const handleClose = () => {
    onClose();
  };

  const handleActionClick = (action, row) => {
    if (action === "edit") {
      setSelectedAccessLevel(row);
      setIsAccessLevelEdit(true);
      setOpenAddAccessLevelModal(true);
      console.log("Edit Access Level:", row);
    } else if (action === "delete") {
      accessLevelDelete(row);
    }
  };

  const accessLevelDelete = async (row) => {
    console.log("Delete Access Level:", row);
    try {
      const response = await api.delete(`${RemoveUserAccessLevel}/${row.name}`);
      console.log("Access level deleted successfully", response);
      showNotification("Access level deleted successfully", "success");
      refreshAccessLevels();
    } catch (error) {
      console.error("Error deleting access level:", error);
      showNotification("Error deleting access level", "error");
      return;
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <Header>
        Access Levels
        <div>
          <Button
            variant="contained"
            color="primary"
            onClick={handleAddAccessLevel}
          >
            Add Access Level
          </Button>
          <IconButton
            onClick={handleClose}
            style={{ color: "white", marginLeft: 16 }}
          >
            <CloseIcon />
          </IconButton>
        </div>
      </Header>

      <Content>
        <TableWithPagination
          title="Access Level List"
          columns={columns}
          rows={accessLevels}
          onActionClick={handleActionClick}
          noSearch={true}
          onRefresh={refreshAccessLevels}
        />
      </Content>

      <AddAccessLevelModal
        open={openAddAccessLevelModal}
        onClose={() => {
          setOpenAddAccessLevelModal(false);
        }}
        onSaveSuccess={() => {
          showNotification("Access Level added successfully", "success");
          refreshAccessLevels();
          setOpenAddAccessLevelModal(false);
        }}
        isEdit={isAccessLevelEdit}
        selectedAccessLevel={selectedAccessLevel}
      />

      <Backdrop
        open={accessLevelsLoading}
        style={{ zIndex: 1300, color: "#fff" }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Dialog>
  );
}
